import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORM } from 'utility-ts-datasource';
import { IAPPlannedCourseGroupDatasource } from '../../global/datasources/ap_planned_course_group_datasource';
import { IAPProgramSlotDatasource } from '../../global/datasources/ap_program_slot_datasource';
import { IAPTermsDatasource } from '../../global/datasources/ap_terms_datasource';
import { APCommandUrlServant } from '../../global/servants/ap_command_url_servant';
import { APCourseGroupPayloadServant } from '../../global/servants/ap_course_group_payload_servant';
import { APProgramSlotServant } from '../../global/servants/ap_program_slot_servant';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'advisorSaveCourseGroupToTermCommand',
    function advisorSaveCourseGroupToTermCommand(
      log: any,
      ngAPCourseGroupPayloadServant: APCourseGroupPayloadServant,
      ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
      ngAPTermsDatasource: IAPTermsDatasource,
      ngAPCommandUrlServant: APCommandUrlServant,
      ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
      $http: ng.IHttpService,
      defineCommand: IDefineCommand
    ): ICommand {
      return defineCommand(
        'advisorSaveCourseGroupToTermCommand',
        (deferred: ng.IDeferred<IQuery[]>, term: number, data: any): void => {
          const courseGroupUrl = ngAPCommandUrlServant.get('courseGroup');

          const payload = ngAPCourseGroupPayloadServant.payload({
            course_group: data.course_group,
            program_slot: data.program_slot,
            term
          });

          $http
            .post(courseGroupUrl, payload)
            .then((response: any) => {
              _4.map(response.data.suggested_course_groups, (item: any) => {
                ngAPPlannedCourseGroupDatasource.write([
                  {
                    course_group: item.course_group.nk,
                    id: item.id,
                    program_slot: item.program_slot,
                    term: item.term.id
                  }
                ]);
                APProgramSlotServant.updateCourseGroupPlannedState(ngAPProgramSlotDatasource, item.program_slot);
              });

              deferred.resolve(
                ORM.run(ngAPPlannedCourseGroupDatasource, ngAPProgramSlotDatasource, ngAPTermsDatasource)
              );
            })
            .catch((e: any) => {
              log.issue('failed to save course group');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/commands/advisor_add_course_group_command.ts